import {
  getHorizontalTicketBackgroundClipPath,
  getVerticalTicketBackgroundClipPath,
} from "../utils";

export class HeroTicket {
  container: HTMLDivElement;
  containerResizeObserver: ResizeObserver;
  countdown: HTMLDivElement;
  contestTimestamp: number;

  constructor(contestTimestamp: number) {
    this.contestTimestamp = contestTimestamp;

    this.container = document.querySelector("#hero-ticket") as HTMLDivElement;
    this.containerResizeObserver = new ResizeObserver(this.setTicketClipPath);
    this.countdown = document.querySelector(
      "#hero-ticket-countdown"
    ) as HTMLDivElement;

    this.init();
  }

  init() {
    this.setTicketClipPath();
    this.containerResizeObserver.observe(this.container);
    this.updateCountdown();
  }

  updateCountdown = () => {
    const now = Date.now();
    const targetDateMilliseconds = this.contestTimestamp * 1000;
    const diff = targetDateMilliseconds - now;

    if (diff < 0) {
      this.countdown.innerHTML = `00:00:00:00`;
      return;
    }

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    this.countdown.innerHTML = `${String(days).padStart(2, "0")}:${String(
      hours
    ).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(
      seconds
    ).padStart(2, "0")}`;

    requestAnimationFrame(this.updateCountdown);
  };

  setTicketClipPath = () => {
    const { width: ticketWidth, height: ticketHeight } =
      this.container.getBoundingClientRect();

    const { width: columnOneWidth, height: columnOneHeight } = this.container
      .querySelectorAll("[data-ticket-column]")[0]
      .getBoundingClientRect();
    const { width: columnTwoWidth, height: columnTwoHeight } = this.container
      .querySelectorAll("[data-ticket-column]")[1]
      .getBoundingClientRect();

    const clipPath =
      window.innerWidth > 900
        ? getHorizontalTicketBackgroundClipPath({
            height: ticketHeight,
            columnOneWidth: columnOneWidth,
            columnTwoWidth: columnTwoWidth,
            gap: 10,
            gapInset: 10,
            radius: 2,
          })
        : getVerticalTicketBackgroundClipPath({
            width: ticketWidth,
            columnOneHeight: columnOneHeight,
            columnTwoHeight: columnTwoHeight,
            gap: 10,
            gapInset: 9,
            radius: 2,
          });

    this.container.style.setProperty(
      "--ticket-clip-path",
      `path("${clipPath}")`
    );
  };
}
